import Api from "./Api";
import _ from 'lodash';

export default {
    load(language) {
        return new Promise((resolve, reject) => {
            Api.get(`translations/${language}`).then(({data}) => {
                let result = {};
                _.each(data, (value, path) => {
                    _.set(result, path, value);
                });
                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}